var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_72732",
    "data-name": "Group 72732",
    transform: "translate(-0.391 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 25,
    cy: 25.5,
    rx: 25,
    ry: 25.5,
    transform: "translate(0.391 0)",
    fill: "#ea2525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "microphone",
    d: "M15.055,20.993a5.593,5.593,0,0,1-5.586-5.586V7.586a5.586,5.586,0,1,1,11.173,0v7.821A5.593,5.593,0,0,1,15.055,20.993Zm10.055-5.586a1.117,1.117,0,0,0-2.235,0,7.821,7.821,0,1,1-15.642,0,1.117,1.117,0,0,0-2.235,0,10.055,10.055,0,1,0,20.111,0ZM16.173,27.7V24.345a1.117,1.117,0,0,0-2.235,0V27.7a1.117,1.117,0,0,0,2.235,0Z",
    transform: "translate(9.985 9.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78694",
    "data-name": "Path 78694",
    d: "M37.8,13.061,16.983,40.713",
    transform: "translate(-0.53 -1.554)",
    fill: "none",
    stroke: "#ea2525",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78695",
    "data-name": "Path 78695",
    d: "M37.8,13.061,16.983,40.713",
    transform: "translate(-0.531 -1.473)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnMute);
export default __webpack_public_path__ + "static/media/un-mute.1d48dab8efb3941b7b811dd5aebc80f0.svg";
export { ForwardRef as ReactComponent };